import React from 'react';
import { Button, StatusMessage } from 'is24-corecss';

interface AdminPageProps {
  isRequestInProgress: boolean;
  onResetNavigationDots: () => void;
}

export const AdminPage = ({ isRequestInProgress, onResetNavigationDots }: AdminPageProps) => (
  <div className='grid gutter-vertical-l'>
    <div className='grid-item'>
      <StatusMessage
        headline='Admin Page Request'
        message={isRequestInProgress ? 'Waiting for response' : 'No request in action'}
        statusType='info'
      />
    </div>

    <div className='grid-item'>
      <Button onClick={onResetNavigationDots} appearance='primary'>
        Reset user interactions
      </Button>
    </div>
  </div>
);
